import { Component, Input, ChangeDetectionStrategy, Output, EventEmitter } from '@angular/core';
import { fadeInDownOnEnterAnimation, fadeOutUpOnLeaveAnimation } from 'angular-animations';

@Component({
    selector: 'app-alert',
    templateUrl: './alert.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    animations: [fadeInDownOnEnterAnimation(), fadeOutUpOnLeaveAnimation()],
    standalone: false
})
export class AlertComponent {
    @Input() text: string;
    @Input() type: string;
    @Input() customClass = '';
    @Input() small: boolean;
    @Input() dismissible: boolean;

    public dismissed: boolean;

    @Output() dismiss = new EventEmitter<void>();

    constructor() {}

    public close(): void {
        this.dismissed = true;
        this.dismiss.emit();
    }
}
